/**
 * @Author:
 * @Description:
 * @DateTime: Created in 08:23 2019-07-15
 */

import EnumItem, {enumMixn} from "./enumItem";

/**
 * 日志类型
 */
let EnumLogType = {
	Login: 						new EnumItem('登录', 1),
    Operation: 						new EnumItem('运维', 2),
    Other: 						new EnumItem('其他', 3),
	...enumMixn
}
export default EnumLogType
